import { cn } from '@/lib/utils';

type ProposalStatus =
  | 'draft'
  | 'in_review'
  | 'approved'
  | 'rejected'
  | 'locked'
  | 'cancelled';

interface ProposalStatusBadgeProps {
  status: ProposalStatus;
}

const STATUS_CONFIG: Record<
  ProposalStatus,
  { label: string; className: string }
> = {
  draft: { label: '草稿', className: 'bg-gray-100 text-gray-700' },
  in_review: { label: '审核中', className: 'bg-blue-100 text-blue-700' },
  approved: { label: '已批准', className: 'bg-green-100 text-green-700' },
  rejected: { label: '已拒绝', className: 'bg-red-100 text-red-700' },
  locked: { label: '已锁定', className: 'bg-purple-100 text-purple-700' },
  cancelled: { label: '已取消', className: 'bg-gray-100 text-gray-500' },
};

export function ProposalStatusBadge({ status }: ProposalStatusBadgeProps) {
  const config = STATUS_CONFIG[status] ?? {
    label: status,
    className: 'bg-gray-100 text-gray-700',
  };
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
        config.className,
      )}
    >
      {config.label}
    </span>
  );
}
